// document.addEventListener('DOMContentLoaded', function() {
//   if (document.querySelectorAll('.js-modal').length === 0) {
//     return
//   }
//   const modal = document.querySelector('.js-modal')

//   function modalClose() {
//     modal.classList.add('hideStyle')
//     modal.addEventListener('transitionend', () => {
//       modal.classList.remove('hideStyle')
//       modal.close()
//     },{ once: true })

//   }

//   const opens = document.querySelectorAll('.js-open')
//   opens.forEach((openBtn) => {
//     openBtn.addEventListener('click',() => {
//       // modal.setAttribute('open','')
//       // modal.show()
//       modal.classList.add('hideStyle')
//       modal.showModal()
//       setTimeout(() => {
//         modal.classList.remove('hideStyle')
//       },500)
//   })
//   })
//   document.querySelector('.js-close').addEventListener('click', modalClose)

//   modal.addEventListener('keydown', e => {
//     if(e.key === 'Escape') {
//       e.preventDefault()
//       modalClose()
//     }
//   })

//   modal.addEventListener('click', e => {
//     if (e.target === modal) modalClose()
//   })
// });


document.addEventListener('DOMContentLoaded', function() {
  // カテゴリ管理ページのダイアログ取得と操作
  const modalAll = document.querySelector('.js-modal');

  // ダイアログを開くボタンに対するイベントリスナー設定
  document.querySelectorAll('.js-open').forEach(button => {
    button.addEventListener('click', () => {
      if (modalAll) {
        modalAll.showModal();
      }
    });
  });

  // ショップ設定ページのダイアログ取得と操作
  const emailDialog = document.getElementById('emailDialog');
  const passwordDialog = document.getElementById('passwordDialog');

  if (emailDialog && passwordDialog) {
    document.querySelector('.js-open-email').addEventListener('click', function() {
      emailDialog.showModal();
    });

    document.querySelector('.js-open-password').addEventListener('click', function() {
      passwordDialog.showModal();
    });
  }

  // すべてのモーダルに共通する閉じる処理
  document.querySelectorAll('.js-close').forEach(button => {
    button.addEventListener('click', () => {
      const modal = button.closest('dialog');
      if (modal && modal.open) {
        modal.close();
      }
    });
  });

  // キーボード操作と背景クリックによるモーダルのクローズ設定
  document.querySelectorAll('dialog').forEach(modal => {
    modal.addEventListener('keydown', e => {
      if (e.key === 'Escape' && modal.open) {
        e.preventDefault();
        modal.close();
      }
    });

    modal.addEventListener('click', e => {
      if (e.target === modal) {
        modal.close();
      }
    });
  });
});


